module.exports = __webpack_public_path__ + "static/media/VolumeBoxIcon.2da6153b.png";